module.exports = __webpack_public_path__ + "assets/media/bolt-trio-blue.aa85e6b4.svg";